export default __webpack_public_path__ + "static/media/warning--road-narrows-left-ahead--g1.fd5aa709.png";